export const ENVIRONMENTS_BASE_URL = '/environments';
export const LEGACY_ENVIRONMENTS_BASE_URL = '/environments-v3';

/**
 * Kubernetes label key used to specify the tenancy mode for a cluster.
 * Values are from the AuratypesTenancy enum (e.g., TenancySingle, TenancyMultiple).
 */
export const TENANCY_LABEL_KEY = 'aura.neo4j.io/tenancy';

export const CREATE_CONFIG_FROM_CONFIG_PARAM = 'fromConfig';
export const CREATE_CONFIG_FROM_ENVIRONMENT_PARAM = 'fromEnvironment';

export const DEFAULT_SCALE_UP_HOURS = 4;
export const MIN_SCALE_UP_HOURS = 1;
export const MAX_SCALE_UP_HOURS = 12;

export const ENV_ACTION_TOOLTIPS = {
  scaleUp: {
    enabled: 'Scale up environment',
    extendUptime: 'Extend environment uptime',
    disabled: 'Environment cannot be scaled up in its current state',
  },
  scaleDown: {
    enabled: 'Scale down environment',
    disabled: 'Environment cannot be scaled down in its current state',
  },
  edit: {
    enabled: 'Edit environment',
    disabled: 'Environment cannot be edited in its current state',
  },
  sync: {
    enabled: 'Sync environment with master',
    disabled: 'Environment cannot be synced in its current state',
  },
  delete: {
    enabled: 'Delete environment',
    disabled: 'Environment cannot be deleted in its current state',
  },
  inspect: {
    enabled: 'Inspect environment',
  },
  saveAsConfig: {
    enabled: 'Save environment as config',
  },
};
